import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["especie", "field", "honorario"]

  connect() {

    // Escuta no document para pegar qualquer change, incluindo os do combobox
    this._changeHandler = (e) => {
      const name = e.target?.name
      if (name === "processo[acao]") {
        this.preencherEspecie()
        this.preencherHonorario()
      } else if (name === "processo[tipo_previdencia]") {
        this.preencherHonorario()
        this.destacarCampos()
      }
    }
    this.element.addEventListener("change", this._changeHandler)
    this.destacarCampos()
  }

  disconnect() {
    this.element.removeEventListener("change", this._changeHandler)
  }

  // ─── leitura de valores ─────────────────────────────────────────────────────

  get acaoValue() {
    return this.element.querySelector('input[name="processo[acao]"][data-ui--combobox-target="hidden"]')?.value || ""
  }

  get tipoPrevidenciaValue() {
    return this.element.querySelector('input[name="processo[tipo_previdencia]"][data-ui--combobox-target="hidden"]')?.value || ""
  }

  get honorarioEl() {
    return this.hasHonorarioTarget ? this.honorarioTarget : null
  }

  // ─── lógica ─────────────────────────────────────────────────────────────────

  destacarCampos() {
    const DESTAQUES = {
      "Aposentadoria por Contribuição com Especial":          ["vara", "data_der", "periodo_inss", "valor_causa"],
      "Aposentadoria por Contribuição com Rural":             ["vara", "data_der", "periodo_inss", "valor_causa"],
      "Aposentadoria por Contribuição com Especial e Rural":  ["vara", "data_der", "periodo_inss", "valor_causa", "numero_beneficio"],
      "Aposentadoria por Idade Rural":                        ["vara", "data_der", "valor_causa"],
      "Aposentadoria por Idade Rural - Bóia Fria":            ["vara", "data_der", "valor_causa"],
      "Aposentadoria por Idade Híbrida":                      ["vara", "data_der", "valor_causa", "numero_beneficio", "data_indeferimento", "cid", "especialidade_medica"],
      "Auxílio Doença - Rural":                               ["vara", "data_der", "valor_causa", "numero_beneficio", "data_indeferimento", "cid", "especialidade_medica"],
      "Auxílio Doença - Urbano":                              ["vara", "data_der", "valor_causa", "numero_beneficio", "data_indeferimento", "cid", "especialidade_medica"],
    }

    const campos = DESTAQUES[this.tipoPrevidenciaValue] || []

    this.fieldTargets.forEach(el => {
      const campo = el.dataset.campo
      el.classList.toggle("campo-destaque", campos.includes(campo))
    })
  }

  preencherEspecie() {
    if (this.acaoValue === "Previdenciária" && this.especieTarget.value === "") {
      this.especieTarget.value = "Ação em desfavor ao Instituto Nacional do Seguro Social (INSS)."
    }
  }

  preencherHonorario() {
    if (!this.hasHonorarioTarget) return

    const acao = this.acaoValue
    const tipo = this.tipoPrevidenciaValue
    const m    = (pattern) => tipo.match(pattern)

    // ── TRABALHISTA ─────────────────────────────────────────────────────────────
    if (acao === "Trabalhista" && tipo === "Reclamatória trabalhista declaratória (LTCAT e PPP)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.500,00 (um mil e quinhentos reais)."

    } else if (acao === "Trabalhista" && tipo === "Acordo extrajudicial") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 01 (um) salário mínimo + 15% do proveito econômico."

    } else if (acao === "Trabalhista" && tipo === "Defesa") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 5.000,00 (cinco mil reais), acrescido de R$ 2.000,00 (dois mil reais) em caso de interposição de recurso."

    } else if (acao === "Trabalhista" && tipo === "Acompanhamento em audiência trabalhista") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 600,00 (seiscentos reais)."

    } else if (acao === "Trabalhista" && tipo === "Cálculo (revisão de termo de rescisão)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais)."

    } else if (acao === "Trabalhista" && (tipo === "Cálculo (sem o termo de rescisão)" || tipo === "Cálculo (rescisão sem CTPS anotada)")) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Trabalhista") {
      this.honorarioEl.value = "Pagará o percentual de 30% do proveito econômico no final da ação, inclusive da liberação do FGTS e parcelas de SD quando for o caso."

    // ── PREVIDENCIÁRIA ──────────────────────────────────────────────────────────
    } else if (acao === "Previdenciária" && m(/^Aposentadoria por Contribui/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/^Aposentadoria por Idade/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será 3 (três) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Aposentadoria por Incapacidade Permanente/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Aposentadoria Especial/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Aposentadoria de Professor/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Auxílio Reclusão/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 3 (três) meses do valor concedido do benefício em caso de auxílio reclusão, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial. No caso de renovação de cárcere, pagará o valor de R$ 300,00 (trezentos reais) para cada atualização."

    } else if (acao === "Previdenciária" && tipo.endsWith("Regime Geral (INSS)")) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.000,00 (mil reais)."

    } else if (acao === "Previdenciária" && tipo.endsWith("Regime Próprio")) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 2 salários mínimos."

    } else if (acao === "Previdenciária" && m(/Recurso/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será 1 (um) mês do valor concedido do benefício em caso de auxílio doença e em caso de aposentadoria 4 (quatro) meses do valor do benefício, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Desconto Sindical/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais), mais de 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Isenção de Imposto de Renda/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais), mais de 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Acerto Pós Perícia/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais)."

    } else if (acao === "Previdenciária" && m(/Guia de Complementação/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais)."

    } else if (acao === "Previdenciária" && m(/Ajustes no CNIS/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Previdenciária" && m(/Desbloquear\/bloquear benefício para empréstimo consignado/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais)."

    } else if (acao === "Previdenciária" && m(/Ação de Reconhecimento/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será 1 (um) mês do salário mínimo vigente, mais R$ 500,00 (quinhentos reais) por ano reconhecido e averbado."

    } else if (acao === "Previdenciária" && m(/Cálculo de Revisão de Benefício/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Previdenciária" && m(/Majoração/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) meses da diferença do valor concedido do benefício em caso de majoração, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Mandado de Segurança/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 1 (um) salário mínimo nacional."

    } else if (acao === "Previdenciária" && m(/Auxílio Doença por Incapacidade Temporária/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será 1 (um) mês do valor concedido do benefício, do auxílio doença (na via administrativa) ou 2 (dois) meses (na via judicial), em caso de aposentadoria 4 (quatro) meses do valor do beneficio, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial. O valor investido para a solicitação e acompanhamento administrativo de pedido de prorrogação automática de benefício até 31/12 do ano vigente será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Previdenciária" && m(/Auxílio Doença Acidentário/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 2 (dois) meses do valor concedido do benefício em caso de auxílio doença, ou 4 (quatro) meses do valor concedido do benefício em caso de aposentadoria, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial. O valor investido para solicitar a prorrogação até 31/12 do ano vigente será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Previdenciária" && m(/^Revisão/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) meses da diferença do valor concedido do benefício (em caso de revisão) e 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && tipo === "Reavaliação/Defesa Benefício Assistencial") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais), para análise do caso e apresentação de defesa na via administrativa. Em caso de manutenção ou concessão do benefício após a defesa administrativa, será devido o valor adicional de R$ 1.000,00 (um mil reais). Em caso de indeferimento administrativo e necessidade de ajuizamento de ação judicial, será aplicado novo contrato, com cobrança de 02 (dois) meses do valor do benefício concedido + 30% (trinta por cento) sobre os valores atrasados."

    } else if (acao === "Previdenciária" && m(/^Beneficio Assistencial/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) meses do valor concedido do benefício em caso de benefício assistencial, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/^Pensão/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) meses do valor concedido do benefício em caso de pensão por morte, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Valor não Recebido/)) {
      this.honorarioEl.value = "Pagará 50% (cinquenta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/^Salário Maternidade/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 1 (um) mês do valor concedido do benefício em caso de salário maternidade, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Auxílio Acidente/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) meses do valor concedido do auxílio acidente, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    } else if (acao === "Previdenciária" && m(/Cadastrar\/Renovar Procurador no INSS/)) {
      this.honorarioEl.value = "Pagará taxa no valor de R$ 300,00 (trezentos reais)."

    } else if (acao === "Previdenciária" && m(/^Pedido de Prorroga/)) {
      const anoAtual = new Date().getFullYear()
      this.honorarioEl.value = `O investimento para a solicitação de prorrogação será de R$ 500,00 (quinhentos reais), com prazo até 31/12/${anoAtual}. Em caso de concessão de aposentadoria, será cobrado um valor correspondente a quatro vezes o benefício mensal concedido, acrescido de 30% sobre os valores retroativos, seja na via administrativa ou judicial. Caso o cliente já tenha efetuado pagamentos referentes a contrato de Auxílio-Doença anteriormente concedido, esses valores serão descontados do total devido.`

    } else if (acao === "Previdenciária" && tipo === "Aposentadoria por tempo a pessoa com deficiência") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal deste e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && tipo === "Cumprimento de exigência") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Previdenciária" && tipo === "Salário paternidade") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Conversão de auxílio doença por incapacidade temporária para aposentadoria/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 4 (quatro) vezes o valor mensal do benefício e mais 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && m(/Conversão de auxílio doença em auxílio doença acidentário/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) + 30% dos valores atrasados, na via administrativa ou judicial."

    } else if (acao === "Previdenciária" && tipo === "Atualização de dados cadastrais") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais)."

    } else if (acao === "Previdenciária" && tipo === "Ação de cobrança previdenciária") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) + 30% do proveito econômico."

    } else if (acao === "Previdenciária" && tipo !== "") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será 1 (um) mês do valor concedido do benefício em caso de auxílio doença e em caso de aposentadoria 4 (quatro) meses do valor do benefício, mais 30% (trinta por cento) dos valores atrasados, na via administrativa e judicial."

    // ── CIVIL ───────────────────────────────────────────────────────────────────
    } else if (acao === "Civil" && ["Ação de alimentos proposição", "Ação de alimentos contestação", "Ação de alimentos exoneração", "Ação de revisional de alimentos"].includes(tipo)) {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de 02 salários mínimos + 03x do valor fixado de pensão alimentícia."

    } else if (acao === "Civil" && tipo === "Ação de alimentos execução") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de 02 salários + 25% do proveito econômico."

    } else if (acao === "Civil" && tipo === "Ação de investigação de paternidade") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de investigação de paternidade com alimentos") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais) + 2x do valor fixado de pensão alimentícia."

    } else if (acao === "Civil" && tipo === "Ação de reconhecimento de paternidade em vida") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.500,00 (três mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Ação de reconhecimento de paternidade post mortem") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.000,00 (quatro mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de reconhecimento de paternidade em consensual") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 2.500,00 (dois mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Ação de reconhecimento de união estável em vida") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de reconhecimento de união estável post mortem") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.000,00 (quatro mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de divórcio/dissolução de união consensual (sem bens)") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.000,00 (quatro mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de divórcio/dissolução de união consensual (com bens)") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.000,00 (quatro mil reais) + 10% dos bens."

    } else if (acao === "Civil" && tipo === "Ação de divórcio/dissolução de união extrajudicial") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de divórcio/dissolução de união litigioso (sem bens)") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 5.000,00 (cinco mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de divórcio/dissolução de união litigioso (com bens)") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 5.000,00 a R$ 7.000,00 + 10% dos bens + 03x alimentos fixados ou afastados."

    } else if (acao === "Civil" && tipo === "Ação ou alteração de guarda") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais) + 03x valor dos alimentos fixados."

    } else if (acao === "Civil" && tipo === "Ação de interdição") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.500,00 (três mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Ação de substituição de curador consensual") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.000,00 (três mil reais)."

    } else if (acao === "Civil" && tipo === "Ação de substituição de curador litigioso") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.500,00 (quatro mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Ação de levantamento da interdição") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 3.500,00 (três mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Inventário extrajudicial/consensual") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 5.000,00 (cinco mil reais) + 5% dos bens."

    } else if (acao === "Civil" && tipo === "Inventário litigioso") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 5.000,00 (cinco mil reais) + 10% dos bens ou da cota parte."

    } else if (acao === "Civil" && tipo === "Parecer I") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Parecer II") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 1.000,00 (um mil reais)."

    } else if (acao === "Civil" && tipo === "Parecer III") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 1.500,00 (um mil e quinhentos reais)."

    } else if (acao === "Civil" && tipo === "Ação de usucapião extrajudicial") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 4.000,00 (quatro mil reais) + 5% dos bens."

    } else if (acao === "Civil" && tipo === "Ação de usucapião judicial") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 500,00 a R$ 1.500,00 + 25% do proveito econômico."

    } else if (acao === "Civil" && tipo === "Ação indenizatória") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 500,00 a R$ 1.500,00 + 25% do proveito econômico obtido."

    } else if (acao === "Civil" && tipo === "Notificação extrajudicial") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 300,00 a R$ 600,00."

    } else if (acao === "Civil" && tipo === "Ação de cobrança civil") {
      this.honorarioEl.value = "Pelo serviço prestado o investimento será de R$ 500,00 (quinhentos reais) + 25% do proveito econômico obtido."

    } else if (acao === "Civil" && tipo === "Defesa") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 3.000,00 (três mil reais) + 10% do proveito econômico, para apresentação de defesa em execução."

    } else if (acao === "Civil" && tipo === "Defesa em execução (desbloqueio de valores)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais) + 10% do proveito econômico, por desbloqueio de valores."

    } else if (acao === "Civil" && tipo === "Defesa em execução (negociação)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 01 (um) salário mínimo + 5% sobre o valor da dívida, em caso de êxito."

    } else if (acao === "Civil" && tipo === "Ação de alvará judicial (liberação de valores)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) + 15% do proveito econômico, para liberação de valores."

    } else if (acao === "Civil" && m(/Ação de alvará judicial \(adjudicação/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.500,00 (um mil e quinhentos reais) + 5% sobre o valor dos bens, para adjudicação ou liberação de bens."

    } else if (acao === "Civil" && m(/Ação declaratória de inexist/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) + 25% do proveito econômico."

    } else if (acao === "Civil" && tipo === "Ação de retificação de registro civil") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 02 (dois) salários mínimos, nos casos de retificação de data de nascimento, nome ou sobrenome."

    } else if (acao === "Civil" && tipo === "Ações de saúde (medicamentos)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 01 (um) salário mínimo até a sentença, nos casos de fornecimento de medicamentos, acrescido de R$ 300,00 (trezentos reais) a cada novo pedido."

    } else if (acao === "Civil" && tipo === "Ações de saúde (internação/leito/cirurgia)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de 01 (um) salário mínimo, nos casos de internação, leito ou cirurgia."

    } else if (acao === "Civil" && tipo === "Vaga em creche ou escola") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.000,00 (um mil reais)."

    } else if (acao === "Civil" && tipo === "Execução fiscal de IPT") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) de entrada + 8% sobre o valor negociado, para negociação de pagamento."

    } else if (acao === "Civil" && tipo === "DPVAT") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais) + 25% do proveito econômico."

    } else if (acao === "Civil" && tipo === "DETRAN (recurso administrativo)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais), para recurso administrativo."

    } else if (acao === "Civil" && tipo === "DETRAN (judicial)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.500,00 (um mil e quinhentos reais) + 20% do proveito econômico, para ação judicial."

    } else if (acao === "Civil" && tipo === "DETRAN (apelação)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 3.000,00 (três mil reais) + 20% do proveito econômico."

    } else if (acao === "Civil" && tipo === "Recurso inominado") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 1.000,00 (um mil reais) + 20% do proveito econômico."

    } else if (acao === "Civil" && tipo === "Acompanhamento em audiência cível") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 600,00 (seiscentos reais)."

    } else if (acao === "Civil" && tipo === "Diligências") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) a R$ 1.500,00 (um mil e quinhentos reais), para diligências administrativas ou judiciais."

    } else if (acao === "Civil" && tipo === "Contratos (compra e venda)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 800,00 (oitocentos reais) a R$ 1.500,00 (um mil e quinhentos reais), para contratos de compra e venda."

    } else if (acao === "Civil" && tipo === "Contratos (contratos em geral)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais) a R$ 1.000,00 (um mil reais), para contratos em geral."

    } else if (acao === "Civil" && tipo === "Contratos (revisão de contratos)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 300,00 (trezentos reais), para revisão de contratos."

    } else if (acao === "Civil" && tipo === "Contratos (alterações contratuais)") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 500,00 (quinhentos reais), para alterações contratuais."

    // ── BANCÁRIA ─────────────────────────────────────────────────────────────────
    } else if (acao === "Bancária" && m(/Parecer Bancário/)) {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 2.000,00 (dois mil reais) + 30% do proveito econômico."

    } else if (acao === "Bancária" && tipo === "Notificação extrajudicial") {
      this.honorarioEl.value = "Para elaboração de notificação extrajudicial, será cobrado o valor de R$ 500,00 (quinhentos reais)."

    } else if (acao === "Bancária" && tipo === "RMC/RCC contratado") {
      this.honorarioEl.value = "O investimento inicial é de R$ 500,00 (quinhentos reais), para parecer de contrato bancário. Caso haja a necessidade de ingressar com uma ação, adicional de 30% sobre o proveito econômico obtido."

    } else if (acao === "Bancária" && tipo === "RMC/RCC não contratado") {
      this.honorarioEl.value = "O investimento será de 30% sobre o proveito econômico obtido."

    } else if (acao === "Bancária" && tipo === "Ação de superendividamento") {
      this.honorarioEl.value = "Pelo serviço prestado, o investimento será de R$ 2.000,00 (dois mil reais) + 30% do proveito econômico."
    }
  }
}
